// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e30ddce4","239":"05758ca3","450":"82d9ecab","667":"6b34f892","977":"5d17c5cc"}[chunkId] + ".chunk.js";
};